                                                                                                                                                                 
  //agent profile

        function setProfileImageFields(){

            if( $("#hdnHeadshotImageName").val()==""){
                 $(".headshot-upload").show();
                 $(".headshot-image").hide();
            } else{
               $(".headshot-upload").hide();
               $(".headshot-image").show();
            }
            
            if ( $("#hdnLogoImageName").val()==""){
                 $(".logo-upload").show();
                 $(".logo-image").hide();
            } else{
               $(".logo-upload").hide();
               $(".logo-image").show();
            }

            
        }

        $(function () {
           
            setProfileImageFields();

            $(document).on("dragover", "#drop-area-logo,#drop-area-headshot", function (event) {
                event.preventDefault();
            })

            $(document).on("click", "#drop-area-logo", function (event) {
                var inputFile = $("#drop-input-file-logo");
                if (!inputFile.data("clicked")) {
                    inputFile.data("clicked", true);
                    inputFile.click();
                    inputFile.data("clicked", false);
                }
            });
           
            $(document).on("click", "#drop-area-headshot", function (event) {
               var inputFile = $("#drop-input-file-headshot");
               if (!inputFile.data("clicked")) {
                   inputFile.data("clicked", true);
                   inputFile.click();
                   inputFile.data("clicked", false);
               }
           });

            $(document).on("drop", "#drop-area-logo", function (event) {
                event.preventDefault();
                var files = event.originalEvent.dataTransfer.files;
                doUploadLogoImage(files)
            })
            
            $(document).on("drop", "#drop-area-headshot", function (event) {
                event.preventDefault();
                var files = event.originalEvent.dataTransfer.files;
                doUploadHeadshotImage(files)
            })

            $(document).on("change", "#drop-input-file-logo", function (event) {
                $("#drop-input-file-logo").data("clicked", false);
                var files = $(this)[0].files;
                doUploadLogoImage(files)
            });
            
            $(document).on("change", "#drop-input-file-headshot", function (event) {
                $("#drop-input-file-headshot").data("clicked", false);
                var files = $(this)[0].files;
                doUploadHeadshotImage(files)
            });

        });

        function doUploadLogoImage(files) {

            if (files.length > 0) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var imageData = e.target.result;
                    UploadLogoImage(imageData, files[0].name, 'logo');
                };
                reader.readAsDataURL(files[0]);
            }
        }
        
        function doUploadHeadshotImage(files) {

            if (files.length > 0) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var imageData = e.target.result;
                    UploadHeadshotImage(imageData, files[0].name, 'heashot');
                };
                reader.readAsDataURL(files[0]);
            }
        }

        $(document).on("click", ".remove-logo-image", function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (confirm("Are you sure you want to remove the company logo image?")) {
                var DTO = { 'mode': 'cover' }
                DynaProxy.invoke("DeleteProfileImage", DTO, function (data) {
                    setEditDirty()
                    $("#hdnLogoImageName").val("");
                    $(".logo-image-div").html(data.imghtml);
                    $(".logo-image-note").html(data.imgnote);
                    setProfileImageFields();
                    showSystemNotification('Company logo has been removed. Remember to save your profile changes.');

                }, function (data) {
                    showSupportNotification("Unable to remove the company logo image.");
                })
            }
        })
        
        $(document).on("click", ".remove-headshot-image", function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (confirm("Are you sure you want to remove the agent headshot image?")) {
                var DTO = { 'mode': 'headshot' }
                DynaProxy.invoke("DeleteProfileImage", DTO, function (data) {
                    setEditDirty()
                    $("#hdnHeadshotImageName").val("");
                    $(".headshot-image-div").html(data.imghtml);
                    $(".headshot-image-note").html(data.imgnote);
                    setProfileImageFields();                      
                    showSystemNotification('Agent headshot has been removed. Remember to save your profile changes.');

                }, function (data) {
                    showSupportNotification("Unable to remove the company logo image.");
                })
            }
        })

        function UploadLogoImage(imageData, imageName, mode) {
            var DTO = { 'imageData': imageData, 'imageName': imageName, 'mode': mode }
            DynaProxy.invoke("UploadTripImage", DTO, function (data) {
                if (data.msg != "") {
                    showSystemNotification('Unable to upload the company logo. ' + data.msg);
                } else {
                    showSystemNotification('Company logo been uploaded. Remember to save your profile changes.');
                    $("#hdnLogoImageName").val(data.filename);
                    $(".logo-image-div").html(data.imghtml);
                    $(".logo-image-note").html(data.imgnote);
                    setProfileImageFields();

                }
            }, function (data) {
                showSupportNotification('Unable to upload the company logo.');
            })
        }

         function UploadHeadshotImage(imageData, imageName, mode) {
            var DTO = { 'imageData': imageData, 'imageName': imageName, 'mode': mode }
            DynaProxy.invoke("UploadTripImage", DTO, function (data) {
                if (data.msg != "") {
                    showSystemNotification('Unable to upload the agent headshot. ' + data.msg);
                } else {
                    showSystemNotification('Agent headshot has been uploaded. Remember to save your profile changes.');
                    $("#hdnHeadshotImageName").val(data.filename);
                    $(".headshot-image-div").html(data.imghtml);
                    $(".headshot-image-note").html(data.imgnote);
                    setProfileImageFields();

                }
            }, function (data) {
                showSupportNotification('Unable to upload the agent headshot.');
            })
        }

                       